var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Key = function Key(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.707 3.293a1 1 0 0 0-1.414 0l-7.536 7.535a5 5 0 1 0 1.414 1.414L15 9.415l1.293 1.293a1 1 0 0 0 1.414-1.414L16.414 8 18 6.414l1.293 1.293a1 1 0 1 0 1.414-1.414L19.414 5l.293-.293a1 1 0 0 0 0-1.414ZM5 15a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Key;